import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import Handlebars from "handlebars";
import VideoHelpers from 'video/scripts/video-helpers';


Snappy.Component.ModalVideo = class ModalVideo extends Snappy.BaseComponent {
    static get tagName() {
        return 'modal-video';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();

    }

    setVars() {

        this.$document = $(document);
        this.title = this.$element.data('modalVideoTitle');
        this.videoUrl = this.$element.data('modalVideoUrl');
        this.templateId = 'video-template';
        this.currentSection = this.$element.data('currentSection');
        const $opener = this.$element.find('.js-modal-video-opener');
        this.$opener = $opener.length ? $opener : this.$element;
        this.$duration = this.$element.find('.js-modal-video-duration');
        this.vimeoMetaEndpoint = 'https://vimeo.com/api/oembed.json';
        this.videoHost = (this.videoUrl.indexOf("youtu") > -1) ? 'youtube' : 'vimeo';
        this.formattedDuration = '';
        this.isTracked = false;
        if (this.videoHost === 'youtube' ) {
            this.prepareYoutube();
        }

        if (this.videoHost === 'vimeo' ) {
            this.prepareVimeo();
        }

    }
    setEventListeners() {
        this.$opener.on('click', this.openModal.bind(this));


    }
    prepareYoutube() {
        this.videoId = VideoHelpers.parseYoutubeId(this.videoUrl);
        this.iframeUrl = `//youtube.com/embed/${this.videoId}?autoplay=1`;
    }
    prepareVimeo() {
        this.videoId = VideoHelpers.parseVimeoId(this.videoUrl);
        this.iframeUrl = `//player.vimeo.com/video/${this.videoId}?autoplay=1`;
        if (this.$duration.length) {
            this.getVimeoMetadata();
        }
    }
    getVimeoMetadata() {
            const request = `${this.vimeoMetaEndpoint}?url=${this.videoUrl}`;
            $.get( request, ( data ) => {
                const duration = data.duration;
                this.formattedDuration = VideoHelpers.getFomattedDuration(duration);
                this.$duration.text(this.formattedDuration);
            });

    }
    openModal(e) {
        e.preventDefault();

        const templateSource = $('#'+this.templateId).html();
        const templateFiunc = Handlebars.compile(templateSource);
        const modalHtml = templateFiunc({
            videoUrl: this.iframeUrl
        });
        const modalContent = $(modalHtml);

        this.$window.trigger('modal:openModal', {
            title: this.title,
            videoDuration: this.formattedDuration,
            $view: modalContent,
            $prevElement: this.$element
        });

        if (!this.isTracked) {
            this.isTracked = true;
            this.$window.trigger('gtm:send', [ this.currentSection, 'View Video', this.title]);
        }
    }




}



// WEBPACK FOOTER //
// ./components/modal-video/scripts/modal-video.js